var _polyline, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRidgeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154.41,
    height: 64.619003,
    viewBox: "0 0 154.41 64.619004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "675.22 139.93 634.08 170.7 590.81 139.93",
    strokeMiterlimit: 10,
    fill: "none",
    stroke: "#3f3d56",
    transform: "translate(-555.81,-106.69982)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 84.400024,
    y: 0.00015224158,
    width: 70.010002,
    height: 33.220001,
    rx: 8.5699997,
    fill: "#84c9fb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0.00015224158,
    width: 70.010002,
    height: 33.220001,
    rx: 8.5699997,
    fill: "#fc93c7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRidgeIcon);
export default __webpack_public_path__ + "static/media/ridgeIcon.6bf891f0fd70e2a0740974a0c925931f.svg";
export { ForwardRef as ReactComponent };